(() => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  document.documentElement.classList.add('sh-page-ready');

  window.addEventListener('pageshow', () => {
    document.documentElement.classList.add('sh-page-loaded');
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (!link) return;

    const url = new URL(link.href, window.location.href);

    const isSameSite = url.origin === window.location.origin;
    const isNewTab = link.target === '_blank' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
    const isAnchor = url.pathname === window.location.pathname && url.hash;

    if (!isSameSite || isNewTab || isAnchor || link.hasAttribute('download')) return;

    event.preventDefault();

    document.documentElement.classList.remove('sh-page-loaded');
    document.documentElement.classList.add('sh-page-leaving');

    setTimeout(() => {
      window.location.href = link.href;
    }, 260);
  });
})();